import { J1LeftarrowD, J1RightarrowD } from '@e3dc-react/icons'
import { Box, IconButton, SxProps, Theme, Typography } from '@mui/material'
import React, { useEffect } from 'react'

interface Props {
  currentPage: number
  lastPage: number
  setPage: (notificationIndex: number) => void
  sxStyle?: SxProps<Theme>
}

const FIRST_PAGE_INDEX = 1
const PAGE_OFFSET = 1

/**
 * Paginator which allows to move from one notification to another
 */
const NotificationPagination: React.VFC<Props> = ({ currentPage, lastPage, setPage, sxStyle }) => {
  const onNextNotification = (currentPage: number, lastPage: number): void => {
    if (currentPage === lastPage) return

    const currentPageIndex = currentPage - 1
    setPage(currentPageIndex + PAGE_OFFSET)
  }

  const onPreviousNotification = (currentPage: number): void => {
    if (currentPage === FIRST_PAGE_INDEX) return

    const currentPageIndex = currentPage - 1
    setPage(currentPageIndex - PAGE_OFFSET)
  }

  const getPageIndicator = (currentPage: number, lastPage: number): string => {
    return `${currentPage} / ${lastPage}`
  }

  useEffect(() => {
    if (lastPage < currentPage) onPreviousNotification(currentPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, lastPage])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', ...sxStyle }}>
      <IconButton
        onClick={() => onPreviousNotification(currentPage)}
        sx={{ color: 'text.primary', opacity: currentPage > FIRST_PAGE_INDEX ? 1 : 0.5 }}
      >
        <J1LeftarrowD />
      </IconButton>
      <Typography variant="overline">{getPageIndicator(currentPage, lastPage)}</Typography>
      <IconButton onClick={() => onNextNotification(currentPage, lastPage)} sx={{ color: 'text.primary', opacity: currentPage < lastPage ? 1 : 0.5 }}>
        <J1RightarrowD />
      </IconButton>
    </Box>
  )
}

export default NotificationPagination
